// @flow

import type { FluxStandardAction } from 'flux-standard-action';
import * as ACTIONS from '../constants/actions';

export type ChatThread = {
  id: string,
  title: string | null,
  createdAt: string,
  updatedAt: string,
  pinned: boolean,
  pinnedDate: number | null, // Unix seconds; null whenever pinned is false
};

export type ReducerType = {
  threads: ChatThread[],
  loading: boolean,
  error: boolean,
};

const INITIAL_STATE: ReducerType = {
  threads: [],
  loading: false,
  error: false,
};

export default function chatThreadsReducer(
  state: ReducerType = INITIAL_STATE,
  { type, payload }: FluxStandardAction<string, *>
): ReducerType {
  switch (type) {
    case ACTIONS.FETCH_CHAT_THREADS_REQUEST:
      return { ...state, loading: true, error: false };

    case ACTIONS.FETCH_CHAT_THREADS_SUCCESS:
      return {
        ...state,
        threads: payload.threads || [],
        loading: false,
        error: false,
      };

    case ACTIONS.FETCH_CHAT_THREADS_ERROR:
      return { ...state, loading: false, error: true };

    case ACTIONS.UPDATE_CHAT_THREAD_SUCCESS:
      return {
        ...state,
        threads: state.threads.map((t) =>
          t.id === payload.thread.id ? { ...t, ...payload.thread } : t,
        ),
      };

    case ACTIONS.CLEAR_CHAT_THREADS:
      return INITIAL_STATE;

    case ACTIONS.LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}
